const passThroughClicks = { pointerEvents: "none" };

const PythonIsland = ({
  windowDimensions,
  scale = 1,
  className,
  onClick = () => {},
  style = {},
}) => (
  <svg
    width={windowDimensions.width * windowDimensions.zoom}
    height={windowDimensions.height * windowDimensions.zoom}
    viewBox={`0 0 ${600 * scale} ${652 * scale}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
    id="python-island"
    style={style}
  >
    <mask
      id="path-1-outside-1"
      maskUnits="userSpaceOnUse"
      x="140"
      y="190.82"
      width="320"
      height="320"
      fill="black"
    >
      <rect fill="white" x="140" y="190.82" width="320" height="320" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M370 200.82C358.954 200.82 350 209.774 350 220.82V300.82H170C158.954 300.82 150 309.774 150 320.82V480.82C150 491.865 158.954 500.82 170 500.82H430C441.046 500.82 450 491.865 450 480.82V330.82V320.82V220.82C450 209.774 441.046 200.82 430 200.82H370Z"
      />
    </mask>
    <path
      d="M350 300.82V310.82H360V300.82H350ZM360 220.82C360 215.297 364.477 210.82 370 210.82V190.82C353.431 190.82 340 204.251 340 220.82H360ZM360 300.82V220.82H340V300.82H360ZM170 310.82H350V290.82H170V310.82ZM160 320.82C160 315.297 164.477 310.82 170 310.82V290.82C153.431 290.82 140 304.251 140 320.82H160ZM160 480.82V320.82H140V480.82H160ZM170 490.82C164.477 490.82 160 486.343 160 480.82H140C140 497.388 153.431 510.82 170 510.82V490.82ZM430 490.82H170V510.82H430V490.82ZM440 480.82C440 486.343 435.523 490.82 430 490.82V510.82C446.569 510.82 460 497.388 460 480.82H440ZM440 330.82V480.82H460V330.82H440ZM440 320.82V330.82H460V320.82H440ZM440 220.82V320.82H460V220.82H440ZM430 210.82C435.523 210.82 440 215.297 440 220.82H460C460 204.251 446.569 190.82 430 190.82V210.82ZM370 210.82H430V190.82H370V210.82Z"
      fill="#0B6FFB"
      mask="url(#path-1-outside-1)"
    />
    <mask id="path-3-inside-2" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M370 200.82C358.954 200.82 350 209.774 350 220.82V300.82H170C158.954 300.82 150 309.774 150 320.82V480.82C150 491.865 158.954 500.82 170 500.82H430C441.046 500.82 450 491.865 450 480.82V330.82V320.82V220.82C450 209.774 441.046 200.82 430 200.82H370Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M370 200.82C358.954 200.82 350 209.774 350 220.82V300.82H170C158.954 300.82 150 309.774 150 320.82V480.82C150 491.865 158.954 500.82 170 500.82H430C441.046 500.82 450 491.865 450 480.82V330.82V320.82V220.82C450 209.774 441.046 200.82 430 200.82H370Z"
      fill="#8F613C"
    />
    <path
      d="M350 300.82V302.82H352V300.82H350ZM352 220.82C352 210.879 360.059 202.82 370 202.82V198.82C357.85 198.82 348 208.669 348 220.82H352ZM352 300.82V220.82H348V300.82H352ZM170 302.82H350V298.82H170V302.82ZM152 320.82C152 310.879 160.059 302.82 170 302.82V298.82C157.85 298.82 148 308.669 148 320.82H152ZM152 480.82V320.82H148V480.82H152ZM170 498.82C160.059 498.82 152 490.761 152 480.82H148C148 492.97 157.85 502.82 170 502.82V498.82ZM430 498.82H170V502.82H430V498.82ZM448 480.82C448 490.761 439.941 498.82 430 498.82V502.82C442.15 502.82 452 492.97 452 480.82H448ZM448 330.82V480.82H452V330.82H448ZM448 320.82V330.82H452V320.82H448ZM448 220.82V320.82H452V220.82H448ZM430 202.82C439.941 202.82 448 210.879 448 220.82H452C452 208.669 442.15 198.82 430 198.82V202.82ZM370 202.82H430V198.82H370V202.82Z"
      fill="black"
      mask="url(#path-3-inside-2)"
    />
    <mask id="path-5-inside-3" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M370 151.308C358.954 151.308 350 160.263 350 171.308V251.308H170C158.954 251.308 150 260.263 150 271.308V431.308C150 442.354 158.954 451.308 170 451.308H430C441.046 451.308 450 442.354 450 431.308V281.308V271.308V171.308C450 160.263 441.046 151.308 430 151.308H370Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M370 151.308C358.954 151.308 350 160.263 350 171.308V251.308H170C158.954 251.308 150 260.263 150 271.308V431.308C150 442.354 158.954 451.308 170 451.308H430C441.046 451.308 450 442.354 450 431.308V281.308V271.308V171.308C450 160.263 441.046 151.308 430 151.308H370Z"
      fill="#E1B185"
    />
    <path
      d="M350 251.308V253.308H352V251.308H350ZM352 171.308C352 161.367 360.059 153.308 370 153.308V149.308C357.85 149.308 348 159.158 348 171.308H352ZM352 251.308V171.308H348V251.308H352ZM170 253.308H350V249.308H170V253.308ZM152 271.308C152 261.367 160.059 253.308 170 253.308V249.308C157.85 249.308 148 259.158 148 271.308H152ZM152 431.308V271.308H148V431.308H152ZM170 449.308C160.059 449.308 152 441.249 152 431.308H148C148 443.459 157.85 453.308 170 453.308V449.308ZM430 449.308H170V453.308H430V449.308ZM448 431.308C448 441.249 439.941 449.308 430 449.308V453.308C442.15 453.308 452 443.459 452 431.308H448ZM448 281.308V431.308H452V281.308H448ZM448 271.308V281.308H452V271.308H448ZM448 171.308V271.308H452V171.308H448ZM430 153.308C439.941 153.308 448 161.367 448 171.308H452C452 159.158 442.15 149.308 430 149.308V153.308ZM370 153.308H430V149.308H370V153.308Z"
      fill="black"
      mask="url(#path-5-inside-3)"
    />
    <circle
      cx="300"
      cy="300.82"
      r="20"
      transform="rotate(90 300 300.82)"
      fill="#FFFAE8"
      id="node-target-practice"
    />
    <circle
      cx="200"
      cy="300.82"
      r="20"
      transform="rotate(90 200 300.82)"
      fill="#FFFAE8"
      id="node-hello-world"
    />
    <circle
      cx="200"
      cy="400.82"
      r="20"
      transform="rotate(90 200 400.82)"
      fill="#FFFAE8"
      id="node-start"
    />
    <rect
      x="287.596"
      y="310.82"
      width="86.5958"
      height="20"
      transform="rotate(-180 287.596 310.82)"
      fill="#FFFAE8"
    />
    <rect
      x="290"
      y="398.618"
      width="86.5958"
      height="20"
      transform="rotate(-90 290 398.618)"
      fill="#FFFAE8"
    />
    <rect
      x="190"
      y="401.047"
      width="86.5958"
      height="20"
      transform="rotate(-90 190 401.047)"
      fill="#FFFAE8"
    />
    <circle
      cx="300"
      cy="400.82"
      r="20"
      fill="#FFFAE8"
      id="node-rocket-launch"
    />
    <circle
      cx="400"
      cy="201.047"
      r="20"
      fill="#FFFAE8"
      id="node-powerful-patterns"
    />
    <rect
      width="10"
      height="45.249"
      transform="matrix(-1 0 0 1 265.058 355.586)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <mask
      id="path-16-outside-4"
      maskUnits="userSpaceOnUse"
      x="242.058"
      y="337.866"
      width="36"
      height="56"
      fill="black"
    >
      <rect fill="white" x="242.058" y="337.866" width="36" height="56" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M244.058 368.366L260.058 339.866L276.058 368.366L264.558 365.366L270.558 369.866L276.058 379.366L264.558 376.366L270.058 380.366L276.058 391.366H260.058H244.058L250.058 380.366L255.558 376.366L244.058 379.366L249.558 369.866L255.558 365.366L244.058 368.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M244.058 368.366L260.058 339.866L276.058 368.366L264.558 365.366L270.558 369.866L276.058 379.366L264.558 376.366L270.058 380.366L276.058 391.366H260.058H244.058L250.058 380.366L255.558 376.366L244.058 379.366L249.558 369.866L255.558 365.366L244.058 368.366Z"
      fill="#009B47"
    />
    <path
      d="M260.058 339.866L261.802 338.887C261.448 338.257 260.781 337.866 260.058 337.866C259.334 337.866 258.668 338.257 258.314 338.887L260.058 339.866ZM244.058 368.366L242.314 367.387C241.921 368.087 241.984 368.953 242.474 369.588C242.964 370.223 243.786 370.504 244.562 370.301L244.058 368.366ZM276.058 368.366L275.553 370.301C276.329 370.504 277.151 370.223 277.641 369.588C278.131 368.953 278.194 368.087 277.802 367.387L276.058 368.366ZM264.558 365.366L265.062 363.431C264.138 363.19 263.171 363.637 262.756 364.497C262.341 365.358 262.593 366.393 263.358 366.966L264.558 365.366ZM270.558 369.866L272.288 368.864C272.154 368.631 271.973 368.428 271.758 368.266L270.558 369.866ZM276.058 379.366L275.553 381.301C276.334 381.505 277.16 381.22 277.649 380.578C278.138 379.935 278.193 379.062 277.788 378.364L276.058 379.366ZM264.558 376.366L265.062 374.431C264.132 374.188 263.161 374.642 262.75 375.511C262.339 376.38 262.604 377.418 263.381 377.984L264.558 376.366ZM270.058 380.366L271.813 379.409C271.672 379.148 271.474 378.923 271.234 378.749L270.058 380.366ZM276.058 391.366V393.366C276.763 393.366 277.417 392.994 277.777 392.387C278.138 391.78 278.151 391.028 277.813 390.409L276.058 391.366ZM244.058 391.366L242.302 390.409C241.964 391.028 241.977 391.78 242.338 392.387C242.698 392.994 243.352 393.366 244.058 393.366V391.366ZM250.058 380.366L248.881 378.749C248.642 378.923 248.444 379.148 248.302 379.409L250.058 380.366ZM255.558 376.366L256.734 377.984C257.511 377.418 257.777 376.38 257.365 375.511C256.954 374.642 255.983 374.188 255.053 374.431L255.558 376.366ZM244.058 379.366L242.327 378.364C241.922 379.062 241.977 379.935 242.466 380.578C242.955 381.22 243.782 381.505 244.562 381.301L244.058 379.366ZM249.558 369.866L248.358 368.266C248.142 368.428 247.962 368.631 247.827 368.864L249.558 369.866ZM255.558 365.366L256.758 366.966C257.522 366.393 257.774 365.358 257.359 364.497C256.944 363.637 255.978 363.19 255.053 363.431L255.558 365.366ZM258.314 338.887L242.314 367.387L245.802 369.345L261.802 340.845L258.314 338.887ZM258.314 340.845L274.314 369.345L277.802 367.387L261.802 338.887L258.314 340.845ZM276.562 366.431L265.062 363.431L264.053 367.301L275.553 370.301L276.562 366.431ZM263.358 366.966L269.358 371.466L271.758 368.266L265.758 363.766L263.358 366.966ZM268.827 370.868L274.327 380.368L277.788 378.364L272.288 368.864L268.827 370.868ZM276.562 377.431L265.062 374.431L264.053 378.301L275.553 381.301L276.562 377.431ZM263.381 377.984L268.881 381.984L271.234 378.749L265.734 374.749L263.381 377.984ZM268.302 381.324L274.302 392.324L277.813 390.409L271.813 379.409L268.302 381.324ZM276.058 389.366H260.058V393.366H276.058V389.366ZM244.058 393.366H260.058V389.366H244.058V393.366ZM248.302 379.409L242.302 390.409L245.813 392.324L251.813 381.324L248.302 379.409ZM254.381 374.749L248.881 378.749L251.234 381.984L256.734 377.984L254.381 374.749ZM244.562 381.301L256.062 378.301L255.053 374.431L243.553 377.431L244.562 381.301ZM247.827 368.864L242.327 378.364L245.788 380.368L251.288 370.868L247.827 368.864ZM254.358 363.766L248.358 368.266L250.758 371.466L256.758 366.966L254.358 363.766ZM244.562 370.301L256.062 367.301L255.053 363.431L243.553 366.431L244.562 370.301Z"
      fill="black"
      mask="url(#path-16-outside-4)"
    />
    <circle cx="400" cy="400.82" r="20" fill="#FFFAE8" id="node-make-a-face" />
    <circle cx="400" cy="300.82" r="20" fill="#FFFAE8" id="node-dont-collide" />
    <rect
      x="400"
      y="411.82"
      width="100"
      height="20"
      transform="rotate(-180 400 411.82)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="390"
      y="400.82"
      width="100"
      height="20"
      transform="rotate(-90 390 400.82)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="410"
      y="200.82"
      width="100"
      height="20"
      transform="rotate(90 410 200.82)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <circle
      cx="300.058"
      cy="400.639"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="400.058"
      cy="400.639"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="300.058"
      cy="300.639"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="200.058"
      cy="300.639"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="400.058"
      cy="300.639"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="400.058"
      cy="200.866"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <path d="M170 499.82L169 449.82H171L170 499.82Z" fill="black" />
    <path d="M430 499.82L429 449.82H431L430 499.82Z" fill="black" />
    <rect
      x="326.396"
      y="328.973"
      width="48"
      height="61.8464"
      rx="9"
      fill="#8F613C"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M326.462 342.973C326.462 338.003 330.491 333.973 335.462 333.973H365.462C370.432 333.973 374.462 338.003 374.462 342.973V499.82H326.462V342.973Z"
      fill="#2253E7"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="374.462"
      y="392.82"
      width="18"
      height="8"
      transform="rotate(90 374.462 392.82)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="334.462"
      y="392.82"
      width="18"
      height="8"
      transform="rotate(90 334.462 392.82)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="364.462"
      y="392.82"
      width="18"
      height="8"
      transform="rotate(90 364.462 392.82)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="354.462"
      y="392.82"
      width="18"
      height="8"
      transform="rotate(90 354.462 392.82)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="344.462"
      y="392.82"
      width="18"
      height="8"
      transform="rotate(90 344.462 392.82)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="326.644"
      y="411.82"
      width="47.3277"
      height="10"
      fill="black"
      fillOpacity="0.2"
    />
    <rect
      x="325.479"
      y="444.105"
      width="1.98184"
      height="11.1077"
      fill="black"
    />
    <rect
      x="373.48"
      y="445.774"
      width="1.98184"
      height="11.1077"
      fill="black"
    />
    <rect
      x="1"
      y="1"
      width="28"
      height="8"
      transform="matrix(4.37114e-08 1 1 -4.37114e-08 236.258 371.82)"
      fill="#986F4D"
      stroke="black"
      strokeWidth="2"
      id="node-signpost"
    />
    <rect
      x="-1"
      y="1"
      width="28"
      height="18"
      transform="matrix(-1 0 0 1 254.258 370.82)"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
      id="node-signpost"
    />
    <rect
      width="18"
      height="2"
      transform="matrix(-1 0 0 1 250.258 375.822)"
      fill="black"
      {...passThroughClicks}
    />
    <rect
      width="18"
      height="2"
      transform="matrix(-1 0 0 1 250.258 379.82)"
      fill="black"
      {...passThroughClicks}
    />
    <rect
      width="18"
      height="2"
      transform="matrix(-1 0 0 1 250.258 383.818)"
      fill="black"
      {...passThroughClicks}
    />
    <path
      d="M250.834 375.831L254.861 374.813V376.869L250.834 375.831Z"
      fill="black"
      {...passThroughClicks}
    />
    <path
      d="M231.881 385.802L227.853 386.82L227.853 384.764L231.881 385.802Z"
      fill="black"
    />
    <path
      d="M261.457 276.983H231.457V266.324L242.275 257.572V246.983H251.866L261.457 255.807V276.983Z"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="232.345"
      y="266.814"
      width="28.188"
      height="9.31269"
      fill="#986F4D"
    />
    <path
      d="M269.21 275.986V275.572L268.917 275.279L264.401 270.763L264.108 270.47H263.694H257.372H256.958L256.665 270.763L252.149 275.279L251.856 275.572V275.986V280.502V281.502H252.856H268.21H269.21V280.502V275.986Z"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="252.856"
      y="276.076"
      width="15.3536"
      height="4.42544"
      fill="#986F4D"
    />
    <path
      d="M375.058 165.69V165.276L375.351 164.983L384.174 156.159L384.467 155.866H384.881H397.234H397.648L397.941 156.159L406.765 164.983L407.058 165.276V165.69V174.513V175.513H406.058H376.058H375.058V174.513V165.69Z"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      width="30"
      height="8.64706"
      transform="matrix(-1 0 0 1 406.058 165.866)"
      fill="#986F4D"
    />
    <rect
      width="10"
      height="45.249"
      transform="matrix(-1 0 0 1 415.058 130.586)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <mask
      id="path-55-outside-5"
      maskUnits="userSpaceOnUse"
      x="392.058"
      y="112.866"
      width="36"
      height="56"
      fill="black"
    >
      <rect fill="white" x="392.058" y="112.866" width="36" height="56" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.058 143.366L410.058 114.866L426.058 143.366L414.558 140.366L420.558 144.866L426.058 154.366L414.558 151.366L420.058 155.366L426.058 166.366H410.058H394.058L400.058 155.366L405.558 151.366L394.058 154.366L399.558 144.866L405.558 140.366L394.058 143.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M394.058 143.366L410.058 114.866L426.058 143.366L414.558 140.366L420.558 144.866L426.058 154.366L414.558 151.366L420.058 155.366L426.058 166.366H410.058H394.058L400.058 155.366L405.558 151.366L394.058 154.366L399.558 144.866L405.558 140.366L394.058 143.366Z"
      fill="#009B47"
    />
    <path
      d="M410.058 114.866L411.802 113.887C411.448 113.257 410.781 112.866 410.058 112.866C409.334 112.866 408.668 113.257 408.314 113.887L410.058 114.866ZM394.058 143.366L392.314 142.387C391.921 143.087 391.984 143.953 392.474 144.588C392.964 145.223 393.786 145.504 394.562 145.301L394.058 143.366ZM426.058 143.366L425.553 145.301C426.329 145.504 427.151 145.223 427.641 144.588C428.131 143.953 428.194 143.087 427.802 142.387L426.058 143.366ZM414.558 140.366L415.062 138.431C414.138 138.19 413.171 138.637 412.756 139.497C412.341 140.358 412.593 141.393 413.358 141.966L414.558 140.366ZM420.558 144.866L422.288 143.864C422.154 143.631 421.973 143.428 421.758 143.266L420.558 144.866ZM426.058 154.366L425.553 156.301C426.334 156.505 427.16 156.22 427.649 155.578C428.138 154.935 428.193 154.062 427.788 153.364L426.058 154.366ZM414.558 151.366L415.062 149.431C414.132 149.188 413.161 149.642 412.75 150.511C412.339 151.38 412.604 152.418 413.381 152.984L414.558 151.366ZM420.058 155.366L421.813 154.409C421.672 154.148 421.474 153.923 421.234 153.749L420.058 155.366ZM426.058 166.366V168.366C426.763 168.366 427.417 167.994 427.777 167.387C428.138 166.78 428.151 166.028 427.813 165.409L426.058 166.366ZM394.058 166.366L392.302 165.409C391.964 166.028 391.977 166.78 392.338 167.387C392.698 167.994 393.352 168.366 394.058 168.366V166.366ZM400.058 155.366L398.881 153.749C398.642 153.923 398.444 154.148 398.302 154.409L400.058 155.366ZM405.558 151.366L406.734 152.984C407.511 152.418 407.777 151.38 407.365 150.511C406.954 149.642 405.983 149.188 405.053 149.431L405.558 151.366ZM394.058 154.366L392.327 153.364C391.922 154.062 391.977 154.935 392.466 155.578C392.955 156.22 393.782 156.505 394.562 156.301L394.058 154.366ZM399.558 144.866L398.358 143.266C398.142 143.428 397.962 143.631 397.827 143.864L399.558 144.866ZM405.558 140.366L406.758 141.966C407.522 141.393 407.774 140.358 407.359 139.497C406.944 138.637 405.978 138.19 405.053 138.431L405.558 140.366ZM408.314 113.887L392.314 142.387L395.802 144.345L411.802 115.845L408.314 113.887ZM408.314 115.845L424.314 144.345L427.802 142.387L411.802 113.887L408.314 115.845ZM426.562 141.431L415.062 138.431L414.053 142.301L425.553 145.301L426.562 141.431ZM413.358 141.966L419.358 146.466L421.758 143.266L415.758 138.766L413.358 141.966ZM418.827 145.868L424.327 155.368L427.788 153.364L422.288 143.864L418.827 145.868ZM426.562 152.431L415.062 149.431L414.053 153.301L425.553 156.301L426.562 152.431ZM413.381 152.984L418.881 156.984L421.234 153.749L415.734 149.749L413.381 152.984ZM418.302 156.324L424.302 167.324L427.813 165.409L421.813 154.409L418.302 156.324ZM426.058 164.366H410.058V168.366H426.058V164.366ZM394.058 168.366H410.058V164.366H394.058V168.366ZM398.302 154.409L392.302 165.409L395.813 167.324L401.813 156.324L398.302 154.409ZM404.381 149.749L398.881 153.749L401.234 156.984L406.734 152.984L404.381 149.749ZM394.562 156.301L406.062 153.301L405.053 149.431L393.553 152.431L394.562 156.301ZM397.827 143.864L392.327 153.364L395.788 155.368L401.288 145.868L397.827 143.864ZM404.358 138.766L398.358 143.266L400.758 146.466L406.758 141.966L404.358 138.766ZM394.562 145.301L406.062 142.301L405.053 138.431L393.553 141.431L394.562 145.301Z"
      fill="black"
      mask="url(#path-55-outside-5)"
    />
    <rect
      width="10"
      height="45.249"
      transform="matrix(-1 0 0 1 362.058 265.586)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <mask
      id="path-58-outside-6"
      maskUnits="userSpaceOnUse"
      x="339.058"
      y="247.866"
      width="36"
      height="56"
      fill="black"
    >
      <rect fill="white" x="339.058" y="247.866" width="36" height="56" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M341.058 278.366L357.058 249.866L373.058 278.366L361.558 275.366L367.558 279.866L373.058 289.366L361.558 286.366L367.058 290.366L373.058 301.366H357.058H341.058L347.058 290.366L352.558 286.366L341.058 289.366L346.558 279.866L352.558 275.366L341.058 278.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M341.058 278.366L357.058 249.866L373.058 278.366L361.558 275.366L367.558 279.866L373.058 289.366L361.558 286.366L367.058 290.366L373.058 301.366H357.058H341.058L347.058 290.366L352.558 286.366L341.058 289.366L346.558 279.866L352.558 275.366L341.058 278.366Z"
      fill="#009B47"
    />
    <path
      d="M357.058 249.866L358.802 248.887C358.448 248.257 357.781 247.866 357.058 247.866C356.334 247.866 355.668 248.257 355.314 248.887L357.058 249.866ZM341.058 278.366L339.314 277.387C338.921 278.087 338.984 278.953 339.474 279.588C339.964 280.223 340.786 280.504 341.562 280.301L341.058 278.366ZM373.058 278.366L372.553 280.301C373.329 280.504 374.151 280.223 374.641 279.588C375.131 278.953 375.194 278.087 374.802 277.387L373.058 278.366ZM361.558 275.366L362.062 273.431C361.138 273.19 360.171 273.637 359.756 274.497C359.341 275.358 359.593 276.393 360.358 276.966L361.558 275.366ZM367.558 279.866L369.288 278.864C369.154 278.631 368.973 278.428 368.758 278.266L367.558 279.866ZM373.058 289.366L372.553 291.301C373.334 291.505 374.16 291.22 374.649 290.578C375.138 289.935 375.193 289.062 374.788 288.364L373.058 289.366ZM361.558 286.366L362.062 284.431C361.132 284.188 360.161 284.642 359.75 285.511C359.339 286.38 359.604 287.418 360.381 287.984L361.558 286.366ZM367.058 290.366L368.813 289.409C368.672 289.148 368.474 288.923 368.234 288.749L367.058 290.366ZM373.058 301.366V303.366C373.763 303.366 374.417 302.994 374.777 302.387C375.138 301.78 375.151 301.028 374.813 300.409L373.058 301.366ZM341.058 301.366L339.302 300.409C338.964 301.028 338.977 301.78 339.338 302.387C339.698 302.994 340.352 303.366 341.058 303.366V301.366ZM347.058 290.366L345.881 288.749C345.642 288.923 345.444 289.148 345.302 289.409L347.058 290.366ZM352.558 286.366L353.734 287.984C354.511 287.418 354.777 286.38 354.365 285.511C353.954 284.642 352.983 284.188 352.053 284.431L352.558 286.366ZM341.058 289.366L339.327 288.364C338.922 289.062 338.977 289.935 339.466 290.578C339.955 291.22 340.782 291.505 341.562 291.301L341.058 289.366ZM346.558 279.866L345.358 278.266C345.142 278.428 344.962 278.631 344.827 278.864L346.558 279.866ZM352.558 275.366L353.758 276.966C354.522 276.393 354.774 275.358 354.359 274.497C353.944 273.637 352.978 273.19 352.053 273.431L352.558 275.366ZM355.314 248.887L339.314 277.387L342.802 279.345L358.802 250.845L355.314 248.887ZM355.314 250.845L371.314 279.345L374.802 277.387L358.802 248.887L355.314 250.845ZM373.562 276.431L362.062 273.431L361.053 277.301L372.553 280.301L373.562 276.431ZM360.358 276.966L366.358 281.466L368.758 278.266L362.758 273.766L360.358 276.966ZM365.827 280.868L371.327 290.368L374.788 288.364L369.288 278.864L365.827 280.868ZM373.562 287.431L362.062 284.431L361.053 288.301L372.553 291.301L373.562 287.431ZM360.381 287.984L365.881 291.984L368.234 288.749L362.734 284.749L360.381 287.984ZM365.302 291.324L371.302 302.324L374.813 300.409L368.813 289.409L365.302 291.324ZM373.058 299.366H357.058V303.366H373.058V299.366ZM341.058 303.366H357.058V299.366H341.058V303.366ZM345.302 289.409L339.302 300.409L342.813 302.324L348.813 291.324L345.302 289.409ZM351.381 284.749L345.881 288.749L348.234 291.984L353.734 287.984L351.381 284.749ZM341.562 291.301L353.062 288.301L352.053 284.431L340.553 287.431L341.562 291.301ZM344.827 278.864L339.327 288.364L342.788 290.368L348.288 280.868L344.827 278.864ZM351.358 273.766L345.358 278.266L347.758 281.466L353.758 276.966L351.358 273.766ZM341.562 280.301L353.062 277.301L352.053 273.431L340.553 276.431L341.562 280.301Z"
      fill="black"
      mask="url(#path-58-outside-6)"
    />
    <rect
      width="8.20089"
      height="37.1082"
      transform="matrix(-1 0 0 1 345.279 273.758)"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <mask
      id="path-61-outside-7"
      maskUnits="userSpaceOnUse"
      x="326.058"
      y="258.866"
      width="31"
      height="47"
      fill="black"
    >
      <rect fill="white" x="326.058" y="258.866" width="31" height="47" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M328.058 284.239L341.179 260.866L354.3 284.239L344.869 281.778L349.79 285.469L354.3 293.26L344.869 290.799L349.38 294.08L354.3 303.101H341.179H328.058L332.978 294.08L337.489 290.799L328.058 293.26L332.568 285.469L337.489 281.778L328.058 284.239Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M328.058 284.239L341.179 260.866L354.3 284.239L344.869 281.778L349.79 285.469L354.3 293.26L344.869 290.799L349.38 294.08L354.3 303.101H341.179H328.058L332.978 294.08L337.489 290.799L328.058 293.26L332.568 285.469L337.489 281.778L328.058 284.239Z"
      fill="#009B47"
    />
    <path
      d="M341.179 260.866L342.923 259.887C342.569 259.257 341.902 258.866 341.179 258.866C340.456 258.866 339.789 259.257 339.435 259.887L341.179 260.866ZM328.058 284.239L326.314 283.26C325.921 283.959 325.984 284.826 326.474 285.461C326.964 286.096 327.786 286.376 328.562 286.174L328.058 284.239ZM354.3 284.239L353.796 286.174C354.572 286.376 355.394 286.096 355.884 285.461C356.374 284.826 356.437 283.959 356.044 283.26L354.3 284.239ZM344.869 281.778L345.374 279.843C344.449 279.602 343.483 280.049 343.068 280.91C342.653 281.771 342.905 282.805 343.669 283.378L344.869 281.778ZM349.79 285.469L351.521 284.467C351.386 284.234 351.205 284.03 350.99 283.869L349.79 285.469ZM354.3 293.26L353.796 295.195C354.576 295.399 355.403 295.113 355.892 294.471C356.381 293.829 356.436 292.956 356.031 292.258L354.3 293.26ZM344.869 290.799L345.374 288.864C344.444 288.622 343.473 289.075 343.062 289.944C342.65 290.813 342.916 291.852 343.693 292.417L344.869 290.799ZM349.38 294.08L351.136 293.122C350.994 292.862 350.796 292.637 350.556 292.462L349.38 294.08ZM354.3 303.101V305.101C355.006 305.101 355.66 304.729 356.02 304.122C356.381 303.515 356.394 302.763 356.056 302.143L354.3 303.101ZM328.058 303.101L326.302 302.143C325.964 302.763 325.977 303.515 326.338 304.122C326.698 304.729 327.352 305.101 328.058 305.101V303.101ZM332.978 294.08L331.802 292.462C331.562 292.637 331.364 292.862 331.222 293.122L332.978 294.08ZM337.489 290.799L338.665 292.417C339.442 291.852 339.708 290.813 339.296 289.944C338.885 289.075 337.914 288.622 336.984 288.864L337.489 290.799ZM328.058 293.26L326.327 292.258C325.922 292.956 325.977 293.829 326.466 294.471C326.955 295.113 327.782 295.399 328.562 295.195L328.058 293.26ZM332.568 285.469L331.368 283.869C331.153 284.03 330.972 284.234 330.837 284.467L332.568 285.469ZM337.489 281.778L338.689 283.378C339.453 282.805 339.705 281.771 339.29 280.91C338.875 280.049 337.909 279.602 336.984 279.843L337.489 281.778ZM339.435 259.887L326.314 283.26L329.802 285.218L342.923 261.845L339.435 259.887ZM339.435 261.845L352.557 285.218L356.044 283.26L342.923 259.887L339.435 261.845ZM354.805 282.304L345.374 279.843L344.365 283.714L353.796 286.174L354.805 282.304ZM343.669 283.378L348.59 287.069L350.99 283.869L346.069 280.178L343.669 283.378ZM348.059 286.471L352.57 294.262L356.031 292.258L351.521 284.467L348.059 286.471ZM354.805 291.325L345.374 288.864L344.365 292.735L353.796 295.195L354.805 291.325ZM343.693 292.417L348.204 295.697L350.556 292.462L346.046 289.182L343.693 292.417ZM347.624 295.038L352.545 304.059L356.056 302.143L351.136 293.122L347.624 295.038ZM354.3 301.101H341.179V305.101H354.3V301.101ZM328.058 305.101H341.179V301.101H328.058V305.101ZM331.222 293.122L326.302 302.143L329.813 304.059L334.734 295.038L331.222 293.122ZM336.312 289.182L331.802 292.462L334.154 295.697L338.665 292.417L336.312 289.182ZM328.562 295.195L337.993 292.735L336.984 288.864L327.553 291.325L328.562 295.195ZM330.837 284.467L326.327 292.258L329.788 294.262L334.299 286.471L330.837 284.467ZM336.289 280.178L331.368 283.869L333.768 287.069L338.689 283.378L336.289 280.178ZM328.562 286.174L337.993 283.714L336.984 279.843L327.553 282.304L328.562 286.174Z"
      fill="black"
      mask="url(#path-61-outside-7)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M400 80.8662C400 91.9119 408.954 100.866 420 100.866L500 100.866V180.866C500 191.912 508.954 200.866 520 200.866H580C591.046 200.866 600 191.912 600 180.866V80.8662V20.8662C600 10.8997 592.71 2.63585 583.171 1.11623C582.138 0.951682 581.079 0.866211 580 0.866211L520 0.866219L420 0.866219C408.954 0.866219 400 9.82052 400 20.8662L400 80.8662Z"
      fill="black"
      fillOpacity="0.07"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M200 571.866C200 560.821 191.046 551.866 180 551.866L100 551.866L100 471.866C100 460.82 91.0457 451.866 80 451.866L20 451.866C8.95432 451.866 1.67017e-05 460.82 1.57361e-05 471.866L6.99382e-06 571.866L1.74846e-06 631.866C8.77154e-07 641.833 7.29012 650.097 16.8288 651.616C17.8616 651.781 18.9209 651.866 20 651.866L80 651.866L180 651.866C191.046 651.866 200 642.912 200 631.866L200 571.866Z"
      fill="black"
      fillOpacity="0.07"
    />
    <mask
      id="mask0"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="327"
      y="443"
      width="47"
      height="16"
    >
      <rect
        x="373.461"
        y="458.072"
        width="46"
        height="14.7621"
        transform="rotate(-180 373.461 458.072)"
        fill="#C4C4C4"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M377.26 444.585L368.833 453.012L364.24 448.37L359.647 453.012L355.054 448.37L350.461 453.012L345.868 448.37L341.275 453.012L336.682 448.37L332.09 453.012L322.927 443.85"
        stroke="#63B4FF"
        strokeWidth="6"
      />
    </g>
    <mask
      id="mask1"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="327"
      y="493"
      width="47"
      height="16"
    >
      <rect
        x="373.461"
        y="508.201"
        width="46"
        height="14.7621"
        transform="rotate(-180 373.461 508.201)"
        fill="#0B6FFB"
      />
    </mask>
    <g mask="url(#mask1)">
      <path
        d="M377.26 494.714L368.833 503.141L364.24 498.499L359.647 503.141L355.054 498.499L350.461 503.141L345.868 498.499L341.275 503.141L336.682 498.499L332.09 503.141L322.927 493.978"
        stroke="#0B6FFB"
        strokeWidth="6"
      />
    </g>
  </svg>
);
PythonIsland.propTypes = {
  windowDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    zoom: PropTypes.number,
  }),
  scale: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default PythonIsland;
